import { Checkbox as HeadlessCheckbox } from '@headlessui/react'

interface Props {
  checked: boolean
  onChange: ((checked: boolean) => void) | undefined
  name: string
  id: string
  disabled?: boolean
}

function Checkbox(props: Props) {
  const { checked, onChange, name, id, disabled } = props

  return (
    <HeadlessCheckbox
      name={name}
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className="group block size-5 rounded border border-gray-400 bg-white data-[checked]:bg-primary-500"
    >
      {/* Checkmark icon */}
      <svg
        className="stroke-white opacity-0 group-data-[checked]:opacity-100"
        viewBox="0 0 14 14"
        fill="none"
      >
        <path
          d="M3 8L6 11L11 3.5"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </HeadlessCheckbox>
  )
}

export default Checkbox
